import React, { useState, useEffect } from "react";
import axios from "axios";
import WorkOrderTimeline from "../OwnerDashboard/Actions/WorkOrderTimeline";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Avatar,
  Grid,
  Divider,
  CircularProgress,
  Tabs,
  Tab,
  TextField,
  Modal,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Snackbar, Alert } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import CategoryIcon from "@mui/icons-material/Category";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CommentIcon from "@mui/icons-material/Comment";
import CancelIcon from "@mui/icons-material/Cancel";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useParams, useNavigate } from "react-router-dom";
import Visits from "../WorkorderVisits"
import api, { API_BASE_URL } from "../../utils/api";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDropzone } from "react-dropzone";
import * as MuiIcons from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import PhoneIcon from "@mui/icons-material/Phone";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";


const WorkOrdersDetails = () => {
  const { id } = useParams();
  const theme = useTheme();
const [statuses, setStatuses] = useState([]);

  const navigate = useNavigate();
  const [workOrderDetails, setWorkOrderDetails] = useState(null);
  const [member, setMember] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [imageURL, setImageURL] = useState(null); // State for the fetched image
  const [openImageModal, setOpenImageModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [comments, setComments] = useState([]); // State for comments
  const [newComment, setNewComment] = useState(""); // State for new comment
  const [commentType, setCommentType] = useState(0);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false); // State for comment modal
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [commentImageUrl, setCommentImageUrl] = useState(null);
  const [openCommentImageModal, setOpenCommentImageModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

  
  // Fetch the current logged-in user's ID from localStorage/session
// 🔹 Get user info from localStorage
const storedUser = localStorage.getItem("user");

let parsedUser = null;
let currentUserId = null;
let currentUserName = "Unknown";
let currentUserLastname = "";

if (storedUser) {
  try {
    parsedUser = JSON.parse(storedUser);
    currentUserId = parsedUser?.userId || null;
    currentUserName = parsedUser?.firstName || "Unknown";
    currentUserLastname = parsedUser?.lastName || "";
  } catch (err) {
    console.error("❌ Failed to parse user from localStorage:", err);
  }
}


  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const workOrderResp = await api.get(
          `/getWorkOrders/${id}`
        );
        const workOrderData = workOrderResp.data;

        const memberResp = await api.get(
          `/members/${workOrderData.property_id}`
        );
        const memberData = memberResp.data;

        const usersResp = await api.get(`${API_BASE_URL}/users`);
        const fetchedUsers = usersResp.data;

        const commentsResp = await api.get(
          `/getExternalComments/${id}`
        );
        const fetchedComments = commentsResp.data;
        const statusResp = await api.get(`/statuses`);
setStatuses(statusResp.data);


        setWorkOrderDetails(workOrderData);
        setMember(memberData);
        setUsers(fetchedUsers);
        setComments(fetchedComments);

        // ✅ Fetch image only if workOrderData.upload_urls exists
        if (workOrderData.upload_urls && workOrderData.upload_urls.trim() !== "") {
          const filename = workOrderData.upload_urls.trim();
          const sanitizedFilename = encodeURIComponent(filename.split(/(\\|\/)/g).pop());
          const imageUrl = `${API_BASE_URL}/workorderimages/${sanitizedFilename}`;
          setImageURL(imageUrl);
        } else {
          // Skip image but do not crash or access undefined
          setImageURL(null);
        }
        
        
      } catch (error) {
        console.error("Failed to fetch details:", error);
        setError("Failed to fetch details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [id]); 
  
  const getStatusInfo = (statusName) => {
    return statuses.find((s) => s.statusname === statusName);
  };
  

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setSelectedFile(file);
        setFilePreview(URL.createObjectURL(file));
      }
    },
  });
  

const handleAddComment = async () => {
  if (!newComment.trim()) {
    return alert("Comment cannot be empty.");
  }

  setIsSubmitting(true);

  try {
    const formData = new FormData();
    formData.append("work_order_id", id);
    formData.append("user_id", currentUserId);
    formData.append("comment_text", newComment);
    formData.append("is_internal", 0);
    if (selectedFile) {
      formData.append("upload_urls", selectedFile);
    }

    const response = await api.post(`/addComment`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // Optimistically update UI
    setComments((prevComments) => [
      {
        comment_id: response.data.comment_id,
        comment_text: newComment,
        sent_at: response.data.sent_at || new Date().toISOString(),
        is_internal: commentType === "internal" ? 1 : 0,
        user_name: currentUserName,
        user_lastname: currentUserLastname,
        upload_urls: response.data.upload_urls || null,
      },
      ...prevComments,
    ]);

    // Reset inputs
    setNewComment("");
    setCommentType("external");
    setSelectedFile(null);
    setFilePreview(null);
    setIsCommentModalOpen(false);

    // Show confirmation Snackbar
    setShowConfirm(true);
  } catch (error) {
    console.error("❌ Failed to add comment:", error);
    alert("Failed to add comment. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};



  const calculateDaysOpen = (createdAt) => {
    if (!createdAt) return "N/A"; // Return N/A if no date
  
    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert to days
  };


  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ textAlign: "center", marginTop: 4 }}>
        {error}
      </Typography>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ padding: 3 }}>
        {/* Back Button */}
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ marginBottom: 3 }}
        >
          Back
        </Button>

        <Grid container spacing={3}>
        {/* Member Profile Section */}
{member && (
  <Grid item xs={12} md={4}>
    <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
      <CardContent sx={{ textAlign: "center" }}>
        <Avatar
          src={`${API_BASE_URL}/images/${encodeURIComponent(
            member.PhotoGraphicFileName?.trim() || ""
          )}`}
          alt={member.FirstName}
          sx={{
            width: 120,
            height: 120,
            margin: "0 auto",
            marginBottom: 2,
            border: "4px solid #007bff",
          }}
        />

        <Typography variant="h5" fontWeight="bold">
          {`${member.FirstName} ${member.LastName}`}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          gutterBottom
        >
          Member Code: {member.ClubMemberCode}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ textAlign: "left", pl: 3 }}>
          {/* Birth Date */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <CalendarTodayIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              Birth Date:{" "}
              {member.BirthDate
                ? new Date(member.BirthDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "N/A"}
            </Typography>
          </Box>

          {/* Join Date */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <CalendarTodayIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              Join Date:{" "}
              {member.JoinDate
                ? new Date(member.JoinDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "N/A"}
            </Typography>
          </Box>

          {/* Status */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <InfoIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Chip
              label={member.ClubStatusRuleCode || "Unknown"}
              color="success"
              size="small"
            />
          </Box>

          {/* Address */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <HomeIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              {member.FullAddress || "N/A"}
            </Typography>
          </Box>

          {/* Phone */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PhoneIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              {member.PhoneNumber || "N/A"}
            </Typography>
          </Box>

          {/* Alt Phone */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <ContactPhoneIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              {member.AlternatePhoneNumber || "N/A"}
            </Typography>
          </Box>

          {/* Cell */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <SmartphoneIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              {member.CellPhoneNumber || "N/A"}
            </Typography>
          </Box>

          {/* Email */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <EmailIcon sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="body2">
              {member.EmailAddress || "N/A"}
            </Typography>
          </Box>
        </Box>

        {/* Timeline stays at the bottom */}
        <Divider sx={{ my: 2 }} />
        <Box>
          <WorkOrderTimeline workOrderId={workOrderDetails.order_id} />
        </Box>
      </CardContent>
    </Card>
  </Grid>
)}

       {/* Work Order Details Section with Tabs */}
<Grid item xs={12} md={8}>
  <Card sx={{ p: 3, borderRadius: "12px", backgroundColor: "#ffffff", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
    <CardContent>
{/* 🔥 Days Open Chip - Inside the Work Order Details card (Top-Right) */}
<Box sx={{ display: "flex", justifyContent: "flex-end", position: "relative", mb: 2 }}>
  <Chip
    label={`Opened Since  ${calculateDaysOpen(workOrderDetails?.created_at)} days`}
    sx={{
      backgroundColor: "rgba(132, 155, 6, 0.2)", // Transparent background
      color: "#444", // Dark text for readability
      fontWeight: "bold",
      fontSize: "14px",
      padding: "6px 12px",
      borderRadius: "20px", // Soft rounded edges
      backdropFilter: "blur(8px)", // Subtle blur effect
      border: "1px solid rgba(255, 255, 255, 0.4)", // Soft border
      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", // Light shadow
      transition: "0.3s ease-in-out",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.3)", // Slightly darker on hover
      },
    }}
  />
</Box>




      {/* Section Title */}
      <Typography variant="h5" sx={{ fontWeight: "bold", textAlign: "center", mb: 3 }}>
        Work Order Details
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* Tabs Navigation */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
        sx={{ marginBottom: 3 }}
      >
        <Tab label="Details" />
        <Tab label="Comments" />
        <Tab label="Visits" />
      </Tabs>

      {/* Tab Panels */}
      {activeTab === 0 && (
        <Box sx={{ position: "relative" }}>
          
{/* Image Section */}
{imageURL && (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      mb: 3,
    }}
  >
    <Card
      elevation={3}
      sx={{
        p: 2,
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.03)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          borderRadius: "12px",
        }}
        onClick={() => setOpenImageModal(true)}
      >
        <img
          src={imageURL}
          alt="Work Order Evidence"
          style={{
            width: "100%",
            maxWidth: "200px",
            height: "auto",
            borderRadius: "12px",
            border: "2px solid #ddd",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            transition: "transform 0.2s ease-in-out",
          }}
        />
      </Box>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ mt: 1, textAlign: "center", fontStyle: "italic" }}
      >
        Click to enlarge
      </Typography>
    </Card>
  </Box>
)}

<Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="md">
  <DialogContent sx={{ position: "relative", textAlign: "center" }}>
    <IconButton
      onClick={() => setOpenImageModal(false)}
      sx={{ position: "absolute", top: 8, right: 8 }}
    >
      <CloseIcon />
    </IconButton>
    <img
      src={imageURL}
      alt="Work Order Evidence"
      style={{ width: "100%", maxHeight: "90vh", objectFit: "contain" }}
    />
  </DialogContent>
</Dialog>
          {/* Work Order Details Grid */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <InfoIcon color="primary" />
                <Typography variant="body2">
                <strong>Work Order ID:</strong> {workOrderDetails?.order_id ? `WO-${workOrderDetails.order_id}` : "N/A"}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <HomeIcon color="success" />
                <Typography variant="body2">
                  <strong>Property ID:</strong> {workOrderDetails.property_id || "N/A"}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <DescriptionIcon color="secondary" />
                <Typography variant="body2">
                  <strong>Description:</strong> {workOrderDetails.description || "No Description Available"}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <ListAltIcon  color="secondary" />
                <Typography variant="body2">
                  <strong>Details:</strong> {workOrderDetails.details || "No Description Available"}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <CalendarTodayIcon color="warning" />
                <Typography variant="body2">
                  <strong>Created:</strong> {workOrderDetails.created_at ? new Date(workOrderDetails.created_at).toLocaleString() : "N/A"}
                </Typography>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
              {(() => {
  const statusInfo = getStatusInfo(workOrderDetails.status);
  const IconComponent = statusInfo?.icon && MuiIcons[statusInfo.icon];
  const color = theme.palette[statusInfo?.color]?.main || statusInfo?.color;

  return (
    <>
      {IconComponent && (
        <IconComponent fontSize="small" sx={{ color }} />
      )}
      <Typography variant="body2">
        <strong>Status:</strong>{" "}
        <Chip
          label={statusInfo?.statusname || "Unknown"}
          sx={{ backgroundColor: color, color: "#fff", fontWeight: "bold" }}
        />
      </Typography>
    </>
  );
})()}

                
              </Card>
            </Grid>
          </Grid>
        </Box>
      
)}

               
{activeTab === 2 &&  (
  <Box sx={{ p: 2 }}>
      <Visits work_order_id={id} currentUserId={currentUserId} />
  </Box>
)}
{activeTab === 1 && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2 }}>Comments</Typography>

    {comments.length > 0 ? (
      comments.map((comment) => (
        <Box
          key={comment.comment_id}
          sx={{
            mb: 2,
            p: 2,
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#e3f2fd", // Only external comment color
          }}
        >
          {/* Comment Text */}
          <Typography variant="body2" sx={{ mb: comment.upload_urls ? 1 : 0 }}>
  {comment.comment_text}
</Typography>
{comment.upload_urls && (
  <Box
    sx={{ mt: 1, textAlign: "left", cursor: "pointer" }}
    onClick={() => {
      const url = `${API_BASE_URL}/workorderimages/${encodeURIComponent(comment.upload_urls)}`;
      setCommentImageUrl(url);
      setOpenCommentImageModal(true);
    }}
  >
    <img
      src={`${API_BASE_URL}/workorderimages/${encodeURIComponent(comment.upload_urls)}`}
      alt="Comment Attachment"
      style={{
        maxWidth: "100%",
        maxHeight: 150,
        borderRadius: 8,
        border: "1px solid #ccc",
      }}
    />
    <Typography variant="caption" sx={{ fontStyle: "italic" }}>
      Click to enlarge
    </Typography>
  </Box>
)}



          {/* User & Timestamp */}
          <Typography variant="caption" color="textSecondary">
            Added by {comment.user_name} {comment.user_lastname || ""} on{" "}
            {new Date(comment.sent_at).toLocaleString()}
          </Typography>
        </Box>
      ))
    ) : (
      <Typography variant="body2" color="textSecondary">
        No comments yet. Be the first to add one!
      </Typography>
    )}

    <Button
      variant="contained"
      color="primary"
      onClick={() => setIsCommentModalOpen(true)}
    >
      Add Comment
    </Button>
  </Box>
)}

              </CardContent>
            </Card>
          </Grid>
        </Grid>

         {/* Modal for Adding New Comment */}
         <Modal open={isCommentModalOpen} onClose={() => setIsCommentModalOpen(false)}>
          <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: 400, backgroundColor: "white", padding: 4, borderRadius: 2, boxShadow: 24 
          }}>
            <Typography id="add-comment-modal" variant="h6" sx={{ mb: 2 }}>
              Add Comment
            </Typography>
            <TextField fullWidth label="Comment" multiline rows={3} value={newComment}
              onChange={(e) => setNewComment(e.target.value)} sx={{ mb: 2 }} />

<Box
  {...getRootProps()}
  sx={{
    border: "2px dashed #ccc",
    borderRadius: "8px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    mb: 2,
  }}
>
  <input {...getInputProps()} />
  <Typography>Drag & drop an image, or click to select</Typography>
</Box>

{filePreview && (
  <Box sx={{ textAlign: "center", mb: 2 }}>
    <Typography variant="body2" sx={{ mb: 1 }}>📎 Preview:</Typography>
    <img
      src={filePreview}
      alt="Preview"
      style={{ maxWidth: "100%", maxHeight: 150, borderRadius: 8 }}
    />
  </Box>
)}

            <Button
  fullWidth
  variant="contained"
  color="primary"
  onClick={handleAddComment}
  disabled={isSubmitting}
>
  {isSubmitting ? "Saving..." : "Save Comment"}
</Button>
          </Box>
          
        </Modal>

        
     
      </Box>

      <Dialog open={openCommentImageModal} onClose={() => setOpenCommentImageModal(false)} maxWidth="md">
  <DialogContent sx={{ position: "relative", textAlign: "center" }}>
    <IconButton
      onClick={() => setOpenCommentImageModal(false)}
      sx={{ position: "absolute", top: 8, right: 8 }}
    >
      <CloseIcon />
    </IconButton>
    <img
      src={commentImageUrl}
      alt="Comment Preview"
      style={{ width: "100%", maxHeight: "90vh", objectFit: "contain" }}
    />
  </DialogContent>
</Dialog>

  <Snackbar
  open={showConfirm}
  autoHideDuration={3000}
  onClose={() => setShowConfirm(false)}
  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
>
  <Alert severity="success" sx={{ width: "100%" }}>
    Comment added successfully!
  </Alert>
</Snackbar>    

    </LocalizationProvider>
    
  );
  
};

export default WorkOrdersDetails;
